import { ShieldCheck } from 'lucide-react';
import type { ReactNode } from 'react';
import type { OkdocBrandTheme } from '@/features/okdoc/config';
import { PatientAppFooter } from '@/features/okdoc/components/PatientAppFooter';

interface OkdocShellProps {
  title?: string;
  clinicName: string;
  theme: OkdocBrandTheme;
  subtitle?: string;
  children: ReactNode;
}

export function OkdocShell({ title = 'Подтверждение записи', clinicName, theme, subtitle, children }: OkdocShellProps) {
  const resolvedTitle = (title || '').trim();
  const resolvedClinicName = (clinicName || '').trim();
  const resolvedSubtitle = (subtitle || '').trim();

  return (
    // 13.03.26: базовая оболочка okdoc теперь держит спокойную бренд-палитру tenant'а.
    <div className={`okdoc-public relative min-h-[100svh] overflow-hidden bg-gradient-to-br ${theme.soft} text-slate-900`}>
      <div className="pointer-events-none absolute inset-x-0 top-0 h-72 bg-[radial-gradient(circle_at_top,rgba(255,255,255,0.55),transparent_65%)]" />
      <div className="mx-auto flex min-h-[100svh] max-w-3xl items-start justify-center px-3 py-4 sm:items-center sm:px-6 sm:py-10">
        <div className="w-full overflow-hidden rounded-[24px] border border-slate-200/80 bg-white shadow-[0_28px_80px_-48px_rgba(15,23,42,0.55)] sm:rounded-[32px]">
          <div className={`bg-gradient-to-br ${theme.softPanel} px-5 pb-6 pt-7 sm:px-8 sm:pt-8`}>
            <div className="text-center">
              <div className={`mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-[22px] ${theme.badge} text-white shadow-lg shadow-slate-900/10`}>
              <ShieldCheck className="h-7 w-7" />
              </div>
              <p className={`text-xs font-semibold uppercase tracking-[0.28em] ${theme.accent}`}>okdoc.su</p>
              {resolvedTitle && <h1 className="mt-3 text-2xl font-semibold tracking-tight sm:text-[2.2rem]">{resolvedTitle}</h1>}
              {resolvedClinicName && <p className="mt-3 text-base text-slate-600">{resolvedClinicName}</p>}
              {resolvedSubtitle && <p className="mx-auto mt-2 max-w-xl text-sm leading-6 text-slate-500">{resolvedSubtitle}</p>}
            </div>
          </div>

          <div className="p-4 sm:p-8">
            {children}
          </div>
          <PatientAppFooter />
        </div>
      </div>
    </div>
  );
}
